var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticStyle:{"border-bottom":"1px 0"}},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.appName))]),_vm._l((_vm.allProducts),function(prod){return _c('td',{key:prod},[_c('rates-input',{attrs:{"rates":_vm.getProductRate(prod),"appName":_vm.appName,"prodName":prod}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }